import { LoadingOutlined } from "@ant-design/icons";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import ApplicationRoutes from "./ApplicationRoutes";

import "./style.css";
import { Layout } from "../layout/Layout.tsx";

const Health = lazy(() => import("../pages/Shared/Health/HealthPage"));
const AuthErrorPage = lazy(() => import("../pages/ErrorPages/AuthErrorPage"));

const AuthenticationRequiredRoutes = () => {
  const { error } = useAuth0();

  if (error) {
    return <AuthErrorPage />;
  }

  const ProtectedRoutes = withAuthenticationRequired(ApplicationRoutes, {
    onRedirecting: () => (
      <div className="loading-full-screen">
        <LoadingOutlined style={{ fontSize: 44 }} spin />
      </div>
    ),
  });

  return <ProtectedRoutes />;
};

const AllRoutes = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path="/health" element={<Health />} />
      <Route path="*" element={<AuthenticationRequiredRoutes />} />
    </Route>
  </Routes>
);

export default AllRoutes;
